/** Marker preserved inside Identity Platform's wrapped auth/internal-error. */
export const ADMIN_PASSWORD_SIGN_IN_DISABLED_MARKER =
  "ADMIN_PASSWORD_SIGN_IN_DISABLED";

/**
 * Keep the fallback text human-readable for a brief functions/frontend rollout
 * skew while giving the current client a stable, non-localized marker to map.
 */
export const ADMIN_PASSWORD_SIGN_IN_DISABLED_MESSAGE = `${ADMIN_PASSWORD_SIGN_IN_DISABLED_MARKER}: Admin accounts must sign in with a code sent to their Emerge email.`;

export function isAdminPasswordSignInDisabledMessage(
  message: unknown
): boolean {
  return (
    typeof message === "string" &&
    message.includes(ADMIN_PASSWORD_SIGN_IN_DISABLED_MARKER)
  );
}
